import { Component, input } from '@angular/core';
import { AdmByGradeComponent } from './adm-by-grade/adm-by-grade.component';
import { GenderComponent } from './gender/gender.component';
import { RaceComponent } from './race/race.component';
import { combineLatest, debounceTime, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-demographics',
  standalone: true,
  imports: [CommonModule, AdmByGradeComponent, GenderComponent, RaceComponent],
  templateUrl: './demographics.component.html',
  styleUrl: './demographics.component.scss'
})
export class DemographicsComponent {

  public readonly districtIds = input.required<string[]>();
  public readonly schoolIds = input.required<string[]>();
  public readonly year = input.required<number>();

    protected viewModel$ = combineLatest([
        toObservable(this.districtIds),
        toObservable(this.schoolIds),
        toObservable(this.year)
      ]).pipe(
        debounceTime(300),
      map(([districtIds, schoolIds, year]) => ({districtIds, schoolIds, year})));
}
